import apiWorker from '../apiWorker'

const users =  {
    update : (_id, data) => apiWorker('patch',  `/v1/api/users/${_id}`, data, true),
}

export default users;